import { render } from "./ProductList.vue?vue&type=template&id=423fa809&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=423fa809&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423fa809"]])

export default __exports__